import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of, pipe } from 'rxjs';
import { share, switchMap } from 'rxjs/operators';
import { ToastsAction } from './toasts.action';
import { IToastPayload } from './toast-payload.interface';
import { ToastrService } from 'ngx-toastr';
import { ToastType } from './toast-type.enum';

@Injectable()
export class ToastsEffects {

  toastError$ = createEffect(() => this.actions$
 .pipe(
    ofType(ToastsAction.toastError),
    switchMap((action: any) => {
      this.toastMessage(action.payload);
      return of({
        type: ToastsAction.toastErrorCompleted,
        payload: action.payload
      });
    }),
    share()
  ));

  toastSuccessMessage$ = createEffect(() => this.actions$
    .pipe(
      ofType(ToastsAction.toastSuccessMessage),
      switchMap((action: any) => {
        this.toastMessage(action.payload, ToastType.Success);
        return of({
          type: ToastsAction.toastSuccessMessageCompleted,
          payload: action.payload
        });
      }),
    share()
    ));

  toastInfoMessage$ = createEffect(() => this.actions$
    .pipe(
      ofType(ToastsAction.toastInfoMessage),
      switchMap((action: any) => {
      this.toastMessage(action.payload, ToastType.Info);
      return of({
        type: ToastsAction.toastInfoMessageCompleted,
        payload: action.payload
      });
    }),
    share()
    ));

    constructor(
      private actions$: Actions,
      private toastrService: ToastrService
    ) {}

  /** Exibe um toast na aplicação */
  private toastMessage(
    payload: IToastPayload,
    type: ToastType = ToastType.Error
  ) {
    switch (type) {
      case ToastType.Error:
        this.toastrService.error(payload.message, payload.title);
        break;
      case ToastType.Success:
        this.toastrService.success(payload.message, payload.title);
        break;
      case ToastType.Info:
        this.toastrService.info(payload.message, payload.title);
        break;
      case ToastType.Warning:
        this.toastrService.warning(payload.message, payload.title);
        break;
    }
  }
}
